import type {PS} from '@wix/document-services-types'

const getCompAppData = (ps: PS, componentType: string) => ps.extensionAPI.platform.getBuilderCompAppData(componentType)

export default {
    getCompAppData
}
